import { typography } from '@joor/design-system'
import styled, { css } from 'styled-components'

import { Number } from 'components/Core'

type StyledNumberInputContainerProps = {
  disabled?: boolean
  hasError?: boolean
}

export const StyledInputContainer = styled.div<StyledNumberInputContainerProps>`
  position: relative;
  display: flex;
  box-sizing: border-box;
  background: var(--color-neutral-000-full);
  border: 1px solid var(--color-primary-400);
  border-radius: var(--size-border-radius-small);
  :focus-within {
    outline: none;
  }
  ${(props) =>
    props.hasError
      ? css`
          border: 1px solid var(--color-error-500);
        `
      : props.disabled
        ? css`
            border: 1px solid var(--color-primary-200);
            input::placeholder {
              color: var(--color-primary-200);
            }
          `
        : css`
            &:hover {
              border: 1px solid var(--color-primary-800);
            }
            &:focus-within {
              border: 1px solid var(--color-secondary-800);
            }
          `}
`

export const StyledNumberInput = styled(Number)`
  width: 100%;
  max-width: unset;
  input {
    display: block;
    min-width: 0px;
    flex-grow: 1;
    padding: 0px 12px;
    padding-right: 34px;
    height: 30px;
    background: inherit;
    border: none;
    border-radius: var(--size-border-radius-small);
    ${(props) =>
      props.disabled
        ? typography.alpha.primaryDisabled.body3
        : typography.alpha.primaryInactive.body3};

    &:focus,
    &:hover {
      outline: none;
      border: none;
      ${typography.alpha.primaryActive.body3}
    }

    &::placeholder {
      ${typography.alpha.primaryInactive.body3};
    }

    &::selection {
      ${typography.alpha.primaryActive.body3}
      background-color: var(--color-secondary-200);
    }
  }
`
type LabelTextProps = {
  disabled?: boolean
  hasError: boolean
}

export const LabelText = styled.div<LabelTextProps>`
  margin-bottom: 4px;
  ${(props) =>
    props.disabled
      ? typography.alpha.primaryInactive.body3
      : typography.alpha.primaryActive.body3}
  ${(props) => props.hasError && typography.alpha.error.body3};
`

export const Asterisk = styled.span`
  ${typography.alpha.error.body3};
`

export const Caption = styled.span<LabelTextProps>`
  ${(props) =>
    props.hasError
      ? typography.alpha.error.caption
      : props.disabled
        ? typography.alpha.primaryInactive.caption
        : typography.alpha.primaryActive.caption}
`
